// ** Icon Registry
// Centralne miejsce zarządzania wszystkimi ikonami

import { eyeIcons } from "./eyeIcons";
import { heartIcons } from "./heartIcons";
import { caretIcons } from "./caretIcons";
import { angleIcons } from "./angleIcons";
import { barsIcons } from "./barsIcons";
import { bellIcons } from "./bellIcons";
import { searchIcons } from "./searchIcons";
import { commentIcons } from "./commentIcons";
import { banIcons } from "./banIcons";
import { paperPlaneIcons } from "./paperPlaneIcons";
import { checkIcons } from "./checkIcons";
import { exchangeIcons } from "./exchangeIcons";
import { thIcons } from "./thIcons";
import { squareIcons } from "./squareIcons";
import { listIcons } from "./listIcons";
import { penIcons } from "./penIcons";
import { plusIcons } from "./plusIcons";
import { arrowIcons } from "./arrowIcons";
import { compressIcons } from "./compressIcons";
import { expandIcons } from "./expandIcons";
import { folderIcons } from "./folderIcons";
import { trashIcons } from "./trashIcons";
import { microphoneIcons } from "./microphoneIcons";
import { mapMakerIcons } from "./mapMakerIcons";
import { redoIcons } from "./redoIcons";
import { exclamationIcons } from "./exclamationIcons";
import { playIcons } from "./playIcons";
import { alignLeftIcons } from "./alignLeftIcons";
import { filmIcons } from "./filmIcons";
import { homeIcons } from "./homeIcons";
import { userIcons } from "./userIcons";
import { photoVideoIcons } from "./photoVideoIcons";
import { imageIcons } from "./imageIcons";
import { trophyIcons } from "./trophyIcons";
import { locationIcons } from "./locationIcons";
import { smileIcons } from "./smileIcons";
import { timesIcons } from "./timesIcons";
import { lockIcons } from "./lockIcons";
import { cogIcons } from "./cogIcons";
import { theaterMasksIcons } from "./theaterMasksIcons";
import { utensilsIcons } from "./utensilsIcons";
import { puzzlePieceIcons } from "./puzzlePieceIcons";
import { balanceScaleIcons } from "./balanceScaleIcons";
import { venusMarsIcons } from "./venusMarsIcons";
import { volleyballBallIcons } from "./volleyballBallIcons";
import { volumeIcons } from "./volumeIcons";
import { questionCircleIcons } from "./questionCircleIcons";
import { ellipsisIcons } from "./ellipsisIcons";
import { videoIcons } from "./videoIcons";
import { brandIcons } from "./brandIcons";
import { spinnerIcons } from "./spinnerIcons";
import { swiperNavigationIcons } from "./swiperNavigationIcons";

export const iconRegistry = {
	...eyeIcons,
	...heartIcons,
	...caretIcons,
	...angleIcons,
	...barsIcons,
	...bellIcons,
	...searchIcons,
	...commentIcons,
	...banIcons,
	...paperPlaneIcons,
	...checkIcons,
	...exchangeIcons,
	...thIcons,
	...squareIcons,
	...listIcons,
	...penIcons,
	...plusIcons,
	...arrowIcons,
	...compressIcons,
	...expandIcons,
	...folderIcons,
	...trashIcons,
	...microphoneIcons,
	...mapMakerIcons,
	...redoIcons,
	...exclamationIcons,
	...playIcons,
	...alignLeftIcons,
	...filmIcons,
	...homeIcons,
	...userIcons,
	...photoVideoIcons,
	...imageIcons,
	...trophyIcons,
	...locationIcons,
	...smileIcons,
	...timesIcons,
	...lockIcons,
	...cogIcons,
	...theaterMasksIcons,
	...utensilsIcons,
	...puzzlePieceIcons,
	...balanceScaleIcons,
	...venusMarsIcons,
	...volleyballBallIcons,
	...volumeIcons,
	...questionCircleIcons,
	...ellipsisIcons,
	...videoIcons,
	...brandIcons,
	...spinnerIcons,
	...swiperNavigationIcons,
};

// #####################################################

// Helper function do sprawdzania czy ikona istnieje
export const hasIcon = (iconName, variant = "solid") => {
	return iconRegistry[iconName] && iconRegistry[iconName].variants[variant];
};

// Helper function do pobierania danych ikony
export const getIconData = (iconName, variant = "solid") => {
	if (!hasIcon(iconName, variant)) {
		console.warn(
			`Icon "${iconName}" with variant "${variant}" not found in registry`,
		);
		return null;
	}

	const iconVariant = iconRegistry[iconName].variants[variant];

	// Sprawdź czy ikona ma pojedynczy path czy array pathów
	if (iconVariant.paths) {
		// Zwróć strukturę z array pathów (dla złożonych ikon)
		return {
			viewBox: iconRegistry[iconName].viewBox,
			paths: iconVariant.paths,
			isMultiPath: true,
		};
	}
	// Zwróć klasyczną strukturę z pojedynczym path
	return {
		viewBox: iconRegistry[iconName].viewBox,
		path: iconVariant.path,
		isMultiPath: false,
	};
};

// #####################################################

export default iconRegistry;

// #####################################################
